import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import { TagPushCart } from 'analytics/cart'

import StringFormat from 'utils/StringFormat'
import { removeProduct } from 'store/actions/cart'

import CartEmpty from './CartEmpty'
import CartRemove from './CartRemove'
import CartList from './CartList'

import { Container, Content } from './CartMenu.style'

export const CartMenu = ({ cart, open, remove, validate }) => {
    const [removeModal, setRemoveModal] = useState(false)
    const [id, setId] = useState(null)
    const [value, setValue] = useState(null)
    const [qnt, setQnt] = useState(null)
    const [, setIndex] = useState(null)

    useEffect(() => {
        document.body.classList.add('overflow-hidden')

        return () => document.body.classList.remove('overflow-hidden')
    }, [])

    const confirmRemove = (id, value, qnt) => {
        remove(id)
        const name = StringFormat.nameProducts(id).split(' ')[1]
        TagPushCart.removeFromCart({
            code: id.toString(),
            name: name,
            value: parseFloat(value),
            quantity: parseInt(qnt)
        })
        closeModal()
    }

    const openModal = (id, value, qnt, index) => {
        setRemoveModal(true)
        setId(id)
        setValue(value)
        setQnt(qnt)
        setIndex(index)
    }

    const closeModal = () => {
        setRemoveModal(false)
        setId(null)
        setValue(null)
        setQnt(null)
        setIndex(null)
    }

    if (cart.length === 0) {
        return <CartEmpty open={open} />
    }

    return (
        <Container>
            <Content>
                {removeModal ? (
                    <CartRemove
                        remove={() => confirmRemove(id, value, qnt)}
                        closeModal={closeModal}
                    />
                ) : (
                    <CartList
                        cart={cart}
                        openModal={openModal}
                        open={open}
                        validate={validate}
                    />
                )}
            </Content>
        </Container>
    )
}

const mapDispatchToProps = (dispatch) => ({
    remove: (id) => dispatch(removeProduct(id))
})

export default connect(null, mapDispatchToProps)(CartMenu)
